import type { UserExportDocumentType } from '@/types/userExportSettingsApiTypes';
import type { ExportFormat } from '../types';

export function documentTypeToFormat(documentType: UserExportDocumentType): ExportFormat {
  switch (documentType) {
    case 'PDF':
      return 'pdf';
    case 'CSV':
      return 'csv';
    case 'XLSX':
    case 'SPREADSHEET':
      return 'spreadsheet';
    default:
      return 'pdf';
  }
}

export function formatToDocumentType(format: ExportFormat): UserExportDocumentType {
  if (format === 'pdf') return 'PDF';
  if (format === 'csv') return 'CSV';
  return 'XLSX';
}
